module.exports = __webpack_public_path__ + "img/송리단길 맛집.769fa1ea.png";